import {
  LONG_REQUEST_FEEDBACK_DELAY_MS,
  registerVisibleLoadingScreen,
} from "@/lib/loading-feedback";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import Spinner from "./spinner";

interface LoadingScreenProps {
  message?: string;
  delay?: number;
  /** Shown without the loading delay so links (e.g. sign up) are visible during auth redirect. */
  footer?: ReactNode;
}

export default function LoadingScreen({
  message = "Loading...",
  delay = LONG_REQUEST_FEEDBACK_DELAY_MS,
  footer,
}: LoadingScreenProps) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  useEffect(() => {
    if (!show) return;
    return registerVisibleLoadingScreen();
  }, [show]);

  if (!show && !footer) return null;

  return (
    <div className="flex flex-col items-start gap-4 overflow-visible">
      {show ? (
        <div className="flex items-center gap-4 overflow-visible text-primary">
          <Spinner />
          <p className="whitespace-nowrap text-xl">{message}</p>
        </div>
      ) : null}
      {footer}
    </div>
  );
}
